/**
 * The "Patient Satisfaction Indicators" radar: data.patientSatisfaction from GET /dashboard
 * ({ Satisfaction, Resolution, Responsiveness, Engagement }, each 0-100) as chart points.
 *
 * An indicator the API returns as null has no data in the window. It keeps its axis, at 0,
 * and says "(no data)" so it is not read as a score of 0 (SS-4293).
 */
const hasValue = (value) => typeof value === "number" && Number.isFinite(value);

export const transformSatisfactionData = (data) => {
  const fullMark = 100;
  return Object.entries(data || {}).map(([subject, value]) =>
    hasValue(value)
      ? { subject, Satisfaction: Number(value.toFixed(2)), fullMark }
      : { subject: `${subject} (no data)`, Satisfaction: 0, fullMark }
  );
};
